import { useTranslation } from "react-i18next";
import CdnImage from "../../../../components/image/CdnImage";
import Icon from "../../../../components/image/Icon";
import {
  icPremiumPlusTag,
  icPremiumPlusTagL,
} from "../../../../components/image/image-src";
import { SvgClose } from "../../../../components/svg/SvgClose";
import { useMoney } from "../../../../hooks/useMoney";
import { findPremiumPlusDpPrice } from "../../../../utils/productAttributeUtils";

export const ProductModalHeader = ({
  product,
  closeModal,
}: {
  product?: ProductDetailResponse;
  closeModal?: () => void;
}) => {
  const { formatMoney } = useMoney();
  const premiumPlusPrice = findPremiumPlusDpPrice({ product });
  const { t } = useTranslation();

  const renderIconPremiumPlus = () => {
    if (premiumPlusPrice! > 0) {
      return <Icon src={icPremiumPlusTag} />;
    }
    if (premiumPlusPrice! < 0) {
      return <Icon src={icPremiumPlusTagL} />;
    }
    return null;
  };

  return (
    <div className="relative">
      <CdnImage
        src={product?.thumbnail ?? "https://placehold.co/600x260"}
        className="h-[220px] w-full rounded-tl-[1rem] rounded-tr-[1rem] object-cover"
        onError={(e) => {
          (e.target as HTMLImageElement).src = "https://placehold.co/600x260";
        }}
        alt="banner"
        cdnParams={{
          width: 500,
          format: "webp",
        }}
        loading="eager"
      />
      {closeModal && (
        <button
          type="button"
          className="absolute right-3 top-3 size-8 rounded-full bg-white p-1.5"
          onClick={closeModal}
        >
          <SvgClose />
        </button>
      )}
      {!!premiumPlusPrice && (
        <div className="absolute bottom-0 left-0 flex h-[38px] w-full items-center gap-[8px] bg-[rgba(61,_63,_65,_0.7)] px-4 py-2 backdrop-blur-[2.4px] backdrop-filter">
          {renderIconPremiumPlus()}
          <p className="text-xs text-[#FFFFFF]">
            {premiumPlusPrice > 0
              ? t(
                  "This product is a premium item with an additional charge of",
                  {
                    price: formatMoney(premiumPlusPrice),
                  },
                )
              : t("This product is a light plan and comes with a discount", {
                  price: formatMoney(premiumPlusPrice),
                })}
          </p>
        </div>
      )}
    </div>
  );
};
